module.exports = __webpack_public_path__ + "allegro.png?8a29ff970a2d43c3cdb703de9e8a4864";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/allegro.png
// module id = 545
// module chunks = 2